import React from "react";
import { BookOpen, Download, FileText } from "lucide-react";

export const ProjectsSection: React.FC = () => {
  const kitapcikUrl = `${process.env.PUBLIC_URL}/hackathon_kitapcik.pdf`;

  return (
    <section id="projects" className="py-24 px-4 sm:px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 max-w-3xl mx-auto text-center">
          <h2 className="text-4xl font-extrabold text-gray-900 mb-4">
            Hackathon Projeleri
          </h2>
          <p className="text-gray-600 text-lg leading-relaxed">
            Hackathon kapsamında geliştirilen ve akıllı sulama ile su
            verimliliği alanında yer alan tüm projelerin detaylarına aşağıdaki
            kitapçıktan ulaşabilirsiniz.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow duration-300">
            <span className="absolute top-0 left-0 h-1 w-full bg-green-600" />

            <div className="grid md:grid-cols-5 gap-0">
              {/* Sol - İkon */}
              <div className="md:col-span-2 bg-gray-50 p-10 flex items-center justify-center border-b md:border-b-0 md:border-r border-gray-200">
                <div className="text-center">
                  <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-white border border-gray-200 flex items-center justify-center shadow-sm">
                    <BookOpen className="w-9 h-9 text-green-600" />
                  </div>
                  <span className="inline-block text-xs font-semibold text-gray-500 tracking-widest uppercase">
                    PDF Kitapçık
                  </span>
                </div>
              </div>

              {/* Sağ - İçerik */}
              <div className="md:col-span-3 p-10">
                <div className="flex items-center gap-2 text-green-700 text-xs font-semibold tracking-wider uppercase mb-3">
                  <FileText className="w-4 h-4" />
                  Proje Derlemesi
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-3 leading-snug">
                  Su Hackathonu Proje Kitapçığı
                </h3>

                <p className="text-gray-600 text-sm leading-relaxed mb-6">
                  Hackathon kapsamında geliştirilen tüm projelerin detayları,
                  ekipler ve çözüm önerileri.
                </p>

                <a
                  href={kitapcikUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="
                    inline-flex items-center gap-2
                    px-5 py-2.5
                    text-sm font-medium
                    text-green-700
                    border border-green-600/40
                    rounded-md
                    hover:bg-green-50
                    hover:border-green-600
                    transition
                  "
                >
                  <Download className="w-4 h-4" />
                  Kitapçığı Görüntüle
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
